export default {
  title: {
    en: 'Selected for you',
  },
}
